import React from 'react';
import './PolicyPage.css';
import Footer from './Footer';
import ContactHome from './ContactHome';

const Cookie = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>Cookie Policy</h1>
        <div className="policy-content">
          <section>
            <h2>1. What Are Cookies</h2>
            <p>
              Cookies are small text files that are placed on your computer or mobile device when you visit 
              a website. They are widely used to make websites work more efficiently and provide information 
              to the website owners.
            </p>
          </section>

          <section>
            <h2>2. How We Use Cookies</h2>
            <p>
              We use cookies for various purposes:
            </p>
            <ul>
              <li><strong>Essential Cookies:</strong> Required for the website to function properly</li>
              <li><strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website</li>
              <li><strong>Functional Cookies:</strong> Remember your preferences and settings</li>
              <li><strong>Marketing Cookies:</strong> Used to deliver relevant advertisements</li>
            </ul>
          </section>

          <section>
            <h2>3. Types of Cookies We Use</h2>
            <h3>Session Cookies</h3>
            <p>
              These are temporary cookies that are deleted when you close your browser. They help maintain 
              your session while navigating our website.
            </p>
            <h3>Persistent Cookies</h3>
            <p>
              These cookies remain on your device for a set period or until you delete them. They help us 
              remember your preferences and improve your experience.
            </p>
          </section>

          <section>
            <h2>4. Third-Party Cookies</h2>
            <p>
              We may also use third-party cookies from trusted partners for analytics and advertising purposes. 
              These cookies are subject to the respective third parties' privacy policies.
            </p>
          </section>

          <section>
            <h2>5. Managing Cookies</h2>
            <p>
              You can control and manage cookies in various ways:
            </p>
            <ul>
              <li>Browser settings allow you to refuse or accept cookies</li>
              <li>You can delete cookies that have already been set</li>
              <li>Most browsers automatically accept cookies, but you can modify settings to decline cookies</li>
            </ul>
            <p>
              Please note that disabling cookies may affect the functionality of our website.
            </p>
          </section>

          <section>
            <h2>6. Cookie Consent</h2>
            <p>
              By continuing to use our website, you consent to our use of cookies in accordance with this 
              Cookie Policy. If you do not agree to our use of cookies, you should set your browser settings 
              accordingly or discontinue use of our website.
            </p>
          </section>

          <section>
            <h2>7. Updates to This Policy</h2>
            <p>
              We may update this Cookie Policy from time to time to reflect changes in our practices or for 
              other operational, legal, or regulatory reasons.
            </p>
          </section>

          <section>
            <h2>8. Contact Us</h2>
            <p>
              If you have any questions about our use of cookies, please{' '}
              <button 
                className="policy-email-link"
                onClick={() => window.dispatchEvent(new CustomEvent('openContactForm'))}
              >
                contact us
              </button>.
            </p>
          </section>
        </div>
      </div>
      <ContactHome />
      <Footer />
    </div>
  );
};

export default Cookie;
